<template>
<div class="div0" v-if="main_layer">
    <Map2 id="subarea_m1" type="large" selector="true" :lng="lng" :zoom="zoom" :lat="lat" :start="start" :end="end" :main_layer="main_layer"/>
</div>
</template>

<script>
import Map2 from '@/components/Map2'
import VectorImageLayer from 'ol/layer/VectorImage'

export default {
  name: 'SubArea',
  props: {
  },  
  components: { Map2 },
  
  data () {
    let lat = null
    let lng = null
    let start = null
    let end = null
    let zoom = null
    let main_layer = null
    let overlay = false

    return {
      main_layer, lat, lng, zoom, start, end, overlay
    }
  },
  methods: {
        getParams: function () {
          if (this.$store.getters.countryID){
            let country_obj = this.$store.getters.getCountryById(this.$store.getters.countryID)
            this.start=country_obj.start
            this.end=country_obj.end
            }
        },  
    },
   watch: {
    '$route' () {
      this.getParams()
      //this.$forceUpdate()
    },
  },   
  mounted () {
    this.getParams()
    this.main_layer = new VectorImageLayer({
      name: 'polygon',
      imageRatio: 2,
    })

    //this.$root.$emit('manage_layer')
    //this.$root.$emit('manage_country_polygon')
  }
}
</script>
